'use strict';
import {supportsImportExport} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {getCollection, getDomainLink, getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {getModelState} from '../../app/model/reducers/state';
import {getFullName} from '../../projects/domain/AssetProjectDomain';
import {timerExportActions} from '../actions/timerExportActions';
import {logger} from './logger';

export class TimerExportService {
  static $inject = [
    'AssetProjectDomain',
    'AssetDomain',
    'TaskDomain',
    '$ngRedux',
    '$contextMenu',
  ];

  /**
   * @param AssetProjectDomain
   * @param AssetDomain
   * @param TaskDomain
   * @param {Store} $ngRedux
   * @param $contextMenu
   */
  constructor(
    AssetProjectDomain,
    AssetDomain,
    TaskDomain,
    $ngRedux,
    $contextMenu,
  ) {
    this.AssetProjectDomain = AssetProjectDomain;
    this.AssetDomain = AssetDomain;
    this.TaskDomain = TaskDomain;
    this.$ngRedux = $ngRedux;
    this.$contextMenu = $contextMenu;
  }

  exportOrganization() {
    this.exportModel('organization', 'org', 'organization');
  }

  exportProject() {
    this.exportModel('project', 'project', 'project');
  }

  exportAsset() {
    this.exportModel('asset', 'asset', 'asset');
  }

  exportAssetProject(id) {
    this.AssetProjectDomain.$get(id)
      .then(assetProject =>
        !assetProject ? null : assetProject.getFullName().then(name =>
          this.$ngRedux.dispatch(timerExportActions.showModal({
            targetFilter: {
              project: getLink(assetProject, 'project').id,
              asset: getLink(assetProject, 'asset').id,
            },
            targetData: {
              name: name,
              typeName: 'project',
            },
          }))
        )
      )
      .catch(err => logger.error({err}, 'Failed to retrieve asset project data'));
  }

  exportTask(task) {
    getDomainLink(task, 'project').then(project => {
      if (!project) {
        console.warn(`No project found`);
        return;
      }

      this.$ngRedux.dispatch(timerExportActions.showModal({
        targetFilter: {
          target: {
            id: getId(task),
            collection: getCollection(task),
          },
        },
        targetData: {
          name: task.name,
          typeName: 'task',
          parentName: project.name,
          parentType: 'project',
        },
      }));
    });
  }

  exportAssetTask(task) {
    Promise.props({
      project: getDomainLink(task, 'project'),
      asset: this.AssetDomain.$get(task.ast),
      name: !task.name && getLink(task, 'task').id
        ? this.TaskDomain.$get(getLink(task, 'task').id)
          .then(parent => parent ? parent.name : '')
        : Promise.resolve(task.name),
    }).then(data => {
      if (!data.project || !data.asset) {
        console.warn(`No asset project found`);
        return;
      }

      this.$ngRedux.dispatch(timerExportActions.showModal({
        targetFilter: {
          target: {
            id: getId(task),
            collection: getCollection(task),
          },
        },
        targetData: {
          name: data.name,
          typeName: 'task',
          parentName: getFullName(data.project, data.asset),
          parentType: 'project',
        },
      }));
    });
  }

  /**
   * @param {String} modelProp
   * @param {String} targetFilterProp
   * @param {String} typeName
   * @private
   */
  exportModel(modelProp, targetFilterProp, typeName) {
    const instance = getModelState(this.$ngRedux.getState())[modelProp];
    if (!instance) {
      console.warn(`No ${typeName} loaded`);
      return;
    }
    this.$ngRedux.dispatch(timerExportActions.showModal({
      targetFilter: {
        [targetFilterProp]: getId(instance),
      },
      targetData: {
        name: instance.name,
        typeName,
      },
    }));
  }

  buildContextAction(actions, exportTimerData) {
    const EXPORT_TIMER_DATA = {
      action: {messageId: 'tasks.details.context.export.timer.label', action: exportTimerData},
    };

    if (supportsImportExport()) {
      this.$contextMenu.addAction(actions, EXPORT_TIMER_DATA);
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/timers/services/TimerExportService.js